import { Injectable } from "@angular/core";
import { EventProvider } from "./event/event";
import { SessionProvider } from "./session/session";
import { ConfigProvider } from "./config/config";
// import { TabsPage } from "../pages/tabs/tabs";
// import { EventsLauncherPage } from "../pages/events-launcher/events-launcher";
import { TutorialProvider } from "./tutorial/tutorial";


@Injectable({providedIn:'root'})
export class EventsLauncherService {
    defaultPage = "EventsPage";
    customPage = "LauncherPage";
    hasData: boolean = false;
    isLauncherPage: boolean = false;

    constructor(
        private eventService: EventProvider,
        private sessionService: SessionProvider,
        private tutorialService: TutorialProvider,
        private config: ConfigProvider
        ) { 
          this.update();
        }

    
     getInitialPage(){
        return new Promise(async (resolve, reject) => {
            let isTabsLauncherPage = (await this.config.config).showHide.tabsLauncher;
            if(!isTabsLauncherPage) resolve(this.defaultPage);
            this.tutorialService.isFirstRun().then(isFirstRun => {
                if(isFirstRun) { resolve(this.defaultPage); return; }
                
                this.eventService.getClientEvents().then(events => {
                    if(!this.sessionService.isLoged || !events || events.length == 0){
                        this.hasData = events.length == 0 ? false : true;
                        resolve(this.customPage);
                    }else{
                        resolve(this.defaultPage);
                    }
                }).catch(err => {
                    resolve(this.defaultPage)
                });
            });
        });
    }

    update(){
        this.getInitialPage().then((pageStr: string) => {
            this.isLauncherPage = pageStr.includes("Launcher");
        });
    }
        
}